/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface HarvestDemandPut
 */
export interface HarvestDemandPut {
  /**
   *
   * @type {string}
   * @memberof HarvestDemandPut
   */
  planId: string;
  /**
   *
   * @type {string}
   * @memberof HarvestDemandPut
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof HarvestDemandPut
   */
  startWeek: string;
  /**
   *
   * @type {string}
   * @memberof HarvestDemandPut
   */
  endWeek: string | null;
  /**
   *
   * @type {number}
   * @memberof HarvestDemandPut
   */
  volumePerWeek: number;
  /**
   *
   * @type {boolean}
   * @memberof HarvestDemandPut
   */
  repeatEveryWeek: boolean;
  /**
   *
   * @type {boolean}
   * @memberof HarvestDemandPut
   */
  multiHarvests: boolean;
  /**
   *
   * @type {string}
   * @memberof HarvestDemandPut
   */
  species: HarvestDemandPutSpeciesEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof HarvestDemandPut
   */
  certificates: Array<HarvestDemandPutCertificatesEnum>;
  /**
   *
   * @type {boolean}
   * @memberof HarvestDemandPut
   */
  isActive: boolean;
}

export const HarvestDemandPutSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;

export type HarvestDemandPutSpeciesEnum =
  (typeof HarvestDemandPutSpeciesEnum)[keyof typeof HarvestDemandPutSpeciesEnum];
export const HarvestDemandPutCertificatesEnum = {
  Asc: 'ASC',
  Debio: 'Debio',
  Fos: 'FOS',
  GlobalGap: 'GlobalGAP',
  Naturland: 'Naturland',
  Organic: 'Organic',
  PracticeGaabap: 'Practice_GAABAP',
  SoilAssociation: 'SoilAssociation',
  Gladlaks: 'Gladlaks',
  Stp: 'STP',
} as const;

export type HarvestDemandPutCertificatesEnum =
  (typeof HarvestDemandPutCertificatesEnum)[keyof typeof HarvestDemandPutCertificatesEnum];
